import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: 'A',
  title: 'Paquete de Actividades Integradoras',
  value: '15',
  desc: 'Actividades listas para usar en el aula con diferentes formatos para cada tomo: debates, simulaciones, experimentos, juegos de roles y proyectos colaborativos. Todas adaptadas a la realidad de los 14 países de la región y con materiales accesibles para cualquier escuela.',
  benefit: 'Nunca más improvises una actividad de educación ambiental que no conecte con la realidad de tus alumnos.'
}, {
  id: 'B',
  title: 'Paquete Completo de Evaluaciones y Rúbricas',
  value: '15',
  desc: 'Exámenes listos para los 5 tomos con diferentes niveles de dificultad, rúbricas alineadas a cada contenido, instrumentos de autoevaluación y coevaluación entre pares. Nunca más construyas un examen de educación ambiental desde cero bajo presión.',
  benefit: 'Materiales ya pensados para el aula de secundaria y bachillerato: ahorra horas en cada trimestre.'
}, {
  id: 'C',
  title: 'Glosario Técnico Ambiental',
  value: '12',
  desc: 'Más de doscientos cincuenta términos del lenguaje ambiental definidos en español latino claro y preciso, listo para entregar directamente a tus alumnos. Desde acuífero y albedo hasta zona de sacrificio y ríos voladores.',
  benefit: 'Nunca más pierdas tiempo de clase explicando qué significa cada concepto desde cero.'
}, {
  id: 'D',
  title: 'Proyectos Anuales Completos',
  value: '10',
  desc: 'Proyectos de largo aliento con guías paso a paso para implementar durante todo el año escolar: el Observatorio Climático Escolar, el Banco de Semillas, la Escuela Circular, el Plan de Movilidad Sostenible y la Campaña de Incidencia Ciudadana Ambiental.',
  benefit: 'Sin explicaciones extra. Abres el proyecto, sigues los pasos y tu escuela se transforma.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-dark-border/10" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Incluidos sin costo extra
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-green-dark" data-id="element-19">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-beige-light border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-21">
              <div className="absolute top-0 right-0 bg-gold/10 text-gold-dark px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold-dark mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold text-green-dark mb-2 pr-16" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white px-3 py-1 rounded mb-4 border border-dark-border/10" data-id="element-26">
                <span className="text-dark/60 text-sm" data-id="element-27">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-28">USD {bonus.value}</span>
                </span>
                <span className="text-gold-dark font-bold ml-2" data-id="element-29">→ GRATIS</span>
              </div>

              <p className="text-dark/80 text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-green-medium text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-green-light/50 via-white to-green-light/50 border border-green-medium/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32">
          <p className="text-dark/70 mb-2" data-id="element-33">Valor total de los 4 bonos</p>
          <p className="text-2xl text-dark/50 line-through mb-4" data-id="element-34">USD 52,00</p>
          <p className="text-lg text-green-dark mb-2" data-id="element-35">Tu precio hoy</p>
          <p className="text-5xl font-bold text-gold mb-4" data-id="element-36">🎁 GRATIS</p>
          <p className="text-sm text-green-medium" data-id="element-37">
            Solo incluidos en esta oferta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}